module.exports = __webpack_public_path__ + "static/media/icon-fire-lg.712f5e5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/icon-fire-lg.png
// module id = 1269
// module chunks = 0